const BASE_URL = 'citizen/messages'

export default {
  /*
   * index() lista los avisos de ciudadanos
   */
  index(params) {
    return Vue.http.get(BASE_URL, {params, skipLoading: true}).then(response => response.data)
  },

  /**
   * show() obtiene la informacion de un aviso de ciudadano
   */
  show(id, params = {}) {
    return Vue.http.get(`${BASE_URL}/${id}`, {params}).then(response => response.data.data)
  },

  /**
   * create() permite crear un aviso de ciudadano
   */
  create(data = {}) {
    return Vue.http.post(BASE_URL, {data}).then(response => response.data.data)
  },

  /*
   * chatMessages() lista los mensajes de chat de un aviso de ciudadanos
   */
  chatMessages(id, params = {}) {
    return Vue.http.get(`${BASE_URL}/${id}/chat_messages`, {params}).then(
      response => response.data.data
    )
  },

  /*
   * createChatMessage() crea un nuevo mensaje de chat al aviso indicado
   */
  createChatMessage(id, data = {}) {
    return Vue.http.post(`${BASE_URL}/${id}/chat_messages`, {data}).then(
      response => response.data.data
    )
  },

  listCategory(data = {}){
    return Vue.http.post(`${BASE_URL}/list_category`, {data}).then(
      response => response.data.data
    )
  }
}
